import axios from "axios";
import { useState } from "react";

const useGetTotalRecords = () => {
  const [totalCount, setTotalCount] = useState<Number>(0);
  const [count, setCount] = useState<Number>(0);
  let lastKey: any = null;
  let newURL = "";

  const getTotalRecordsCount = async (
    module: string,
    filtersParam?: string
  ) => {
    setTotalCount(0)
    let url = `${process.env.REACT_APP_API_URL}totalcount?module=${module}`;
    if (filtersParam) url += `&${filtersParam}`;
    try {
      const response = await axios.get(url);
      const totalRecords = response?.data?.result?.count
        ? response?.data?.result?.count
        : response?.data?.result?.totalCount;
        const count = isNaN(Number(totalRecords)) ? 0 : Number(totalRecords);
      setTotalCount(count);
    } catch (msg) {
      console.error("error ", msg);
    }
  };

  const getTotalCounts = async (
    url: string, // needs to send the data without lastkey
    entityPath: string, // needs to send the entity path of the data array
    isPost?: boolean // needs to send the method type
  ) => {
    newURL = url;
    if (lastKey !== null) {
      newURL += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
    }
    try {
      const response = isPost
        ? await axios.post(newURL)
        : await axios.get(newURL);
      const pathArray = entityPath?.split(".");
      const dataEntity = pathArray.splice(
        pathArray.length - 1,
        pathArray.length - 1
      )[0];
      let responseData: any = response;
      pathArray?.forEach((element) => {
        responseData = responseData[element];
      });
      lastKey = responseData?.lastKey;
      const value = responseData[dataEntity]?.length;
      setTotalCount(value);
    } catch (error) {
      console.error(error);
    }
  };

  return { totalCount, getTotalCounts, getTotalRecordsCount };
};

export default useGetTotalRecords;
